<template>
  <div>
    <span class="weui-switch" :class="{'weui-switch-on' : me_checked_calc===1}" :value="value" :shareId="shareId" @click.stop="toggle"></span>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        default: 1
      },
      shareId:{
        type: String,
        default: ''
      }
    },
    data:()=>({
        me_checked: this.value,
        canIClick: true,
    }),
    computed:{
      me_checked_calc(){
          return this.value
      }
    },
    watch: {
      me_checked(val) {
        this.$emit('input', val);
      },
      // me_checked: {
      //   handler: function(val){
      //     this.$emit('input', val);
      //   },
      //   immediate: true
      // }
    },
    methods: {
      toggle() {
        // 防止频繁点击，只有在接口有返回过后才能再次发送请求    防抖与节流不太适合此场景
        if (this.canIClick){
          this.canIClick = false;
          this.Utils.doShareRequest("change_share_upload_status",{shareId:this.shareId}).then(res=>{
            if(res.isUpload == -1){
				if(res.reason=="NotPermission"){
					this.$toast({
					  text: this.$t('language.exception.notPermission'),
					  type: 'fail',
					  idValue: "shareBox"
					});
				}else{
					this.$toast({
					  text: res.message,
					  type: 'fail',
					  idValue: "shareBox"
					});
				}
            }else{
              this.me_checked = res.isUpload
            }
            this.canIClick = true
          })
        }
      }
    }
  }
</script>

<style>
  .weui-switch {
    margin: 0 auto;
    display: block;
    position: relative;
    width: 21px;
    height: 11px;
    border: 1px solid #DFDFDF;
    outline: 0;
    border-radius: 11px;
    box-sizing: border-box;
    background-color: #DFDFDF;
    transition: background-color 0.1s, border 0.1s;
    cursor: pointer;
  }
  .weui-switch:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 10px;
    border-radius: 10px;
    background-color: #FDFDFD;
    transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
  }
  .weui-switch:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #FFFFFF;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  .weui-switch-on {
    border-color: #5166BD;
    background-color: #5166BD;
  }
  .weui-switch-on:before {
    border-color: #5166BD;
    background-color: #5166BD;
  }
  .weui-switch-on:after {
    transform: translateX(10px);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/input/switch.vue